export default __webpack_public_path__ + "static/media/Back Arrow Dark.9cf45433.svg";